// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__210Nw","footer":"Form_footer__K5rb-"};